/*
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: 李勇
 * @Date: 2023-10-26 14:29:17
 * @LastEditors: 陈红伟 chenhw2019@gmail.com
 * @LastEditTime: 2024-01-15 14:41:52
 * @FilePath: /partner.chaoyongtuan.com/src/utils/newDataMap/sampleOrder.js
 *
 * Copyright (c) 2023 by 央选/李勇, All Rights Reserved.
 */

// 商品延长推广时间
export const goodsDelayTimeOptList = [
	{
		label: '1个月',
		value: 1,
	},
	{
		label: '2个月',
		value: 2,
	},
	{
		label: '3个月',
		value: 3,
	},
	{
		label: '6个月',
		value: 6,
	},
	{
		label: '12个月',
		value: 12,
	},
];

export const startTimeMap = {
	SOME: 1,
	COOPERATE: 2,
	CLAIM: 3,
	SEND_SAMPLE: 4,
};

export const orderPayOptMap = {
	THIS_MONTH: 1,
	TWO: 2,
};

export const orderPayOptList = [
	{
		label: '本月',
		value: orderPayOptMap.THIS_MONTH,
	},
	{
		label: '近2个月',
		value: orderPayOptMap.TWO,
	},
];

export const some_time = {
	label: '从指定时间开始',
	value: startTimeMap.SOME,
};

export const cooperate_time = {
	label: '从合作进度创建开始',
	value: startTimeMap.COOPERATE,
};
export const claim_time = {
	label: '从认领时间开始',
	value: startTimeMap.CLAIM,
};

export const drBelongTypeMap = {
	LINK: 0,
	DR: 1,
	COOPERATE: 2,
};

export const cooperate_btn = {
	label: '按合作进度',
	value: drBelongTypeMap.COOPERATE,
};

export const dr_btn = {
	label: '按达人跟进关系',
	value: drBelongTypeMap.DR,
};

export const link_btn = {
	label: '按参数链接',
	value: drBelongTypeMap.LINK,
};

export const timeSinceOptionMap = {
	[drBelongTypeMap.LINK]: () => [],
	[drBelongTypeMap.COOPERATE]: () => {
		return [some_time, cooperate_time];
	},
	[drBelongTypeMap.DR]: vm => {
		const { many_partner } = vm;
		const list = [some_time];
		if (many_partner == 0) {
			list.push(claim_time);
		}
		return list;
	},
};

const getBelongBtns = vm => {
	if (vm.$isDy(vm.platformId)) {
		return vm.many_partner == 1 ? [cooperate_btn, link_btn] : [cooperate_btn, dr_btn, link_btn];
	}
	if (vm.many_partner == 0) {
		return [cooperate_btn, dr_btn];
	} else if (vm.many_partner == 1) {
		return [cooperate_btn];
	}
};

export const drBelongTypesPlatMap = {
	[dataMap.PLATFORM_DY.value]: getBelongBtns,
	[dataMap.PLATFORM_KS.value]: getBelongBtns,
	[dataMap.PLATFORM_SP.value]: getBelongBtns,
};

export default {};
